export const faqItems = [
  {
    id: "faq-1",
    question: "Co to jest USFans Spreadsheet?",
    answer: "USFans Spreadsheet to kompleksowa baza danych zawierająca szczegółowe informacje o twórcach, analizy profili oraz statystyki zaangażowania. Narzędzie zostało stworzone specjalnie dla agencji marketingowych i osób zarządzających kampaniami z twórcami, aby usprawnić proces researchu i podejmowania decyzji."
  },
  {
    id: "faq-2",
    question: "Jak działa baza twórców?",
    answer: "Baza twórców USFans Spreadsheet działa na zasadzie szczegółowego arkusza kalkulacyjnego, który zawiera setki profili twórców posegregowanych według nisz, zasięgów, wskaźników zaangażowania i innych kluczowych metryk. Dane są regularnie aktualizowane, co zapewnia dostęp do aktualnych informacji."
  },
  {
    id: "faq-3",
    question: "Czy dane w USFans Spreadsheet są publiczne?",
    answer: "Dane zawarte w USFans Spreadsheet pochodzą z publicznie dostępnych profili i są gromadzone zgodnie z regulaminami platform społecznościowych. Arkusz agreguje i organizuje te informacje w użyteczny format, oszczędzając godziny ręcznego researchu."
  },
  {
    id: "faq-4",
    question: "Jak korzystać z arkusza USFans Spreadsheet?",
    answer: "Arkusz jest intuicyjny i gotowy do użycia od razu po zakupie. Możesz filtrować twórców według kategorii, sortować według metryk i eksportować dane do własnych narzędzi. Pełna instrukcja znajduje się w naszym poradniku."
  },
  {
    id: "faq-5",
    question: "Czy USFans Spreadsheet jest bezpieczny?",
    answer: "Tak, USFans Spreadsheet wykorzystuje wyłącznie publicznie dostępne dane i nie narusza żadnych regulaminów. Wszystkie informacje są gromadzone i prezentowane w sposób zgodny z obowiązującymi przepisami o ochronie danych i regulaminami platform."
  }
];